$(document).ready(function () {
	$("#loader-blog").css("z-index", -1).hide().removeClass("d-flex");

	$(".single-cat").click(function () {
		$url = $(this).children(".category-title").attr("data-permalink");
		$cat_id = $(this).children(".category-title").attr("data-id");

		maillard_display_blog_cat($url, $cat_id, 1, this);
	});

	initPrevBtn();
	initNextBtn();
});

/**
 * HTML injecté en AJAX : le script WPBakery ne rattache pas les déclencheurs
 * d’animation, les éléments restent avec :not(.wpb_start_animation) → animation: none.
 */
function maillardRevealWpbInjected($root) {
	$root.find(".wpb_animate_when_almost_visible").addClass("wpb_start_animation");
}

function maillard_display_blog_cat(full_url, cat_id, num_page, target) {
	// On ne peut pas re-cliquer sur un élement déja selectionné
	if ($("#cat-" + cat_id).hasClass("selected") && num_page == 0) return;

	// Ajout d'un loader sur la catégorie si on change de catégorie
	$("#loader-blog").css("z-index", 2).show().fadeTo(0.5, 1).addClass("d-flex");

	$("#articles").hide().fadeOut("500");
	$("#maillard-pagination").hide().fadeOut("500").removeClass("d-flex");

	// Met la catégorie en "selected"
	var catName = "#cat-" + cat_id;
	$(".single-cat").removeClass("selected");
	$(catName).addClass("selected");

	$.ajax({
		type: "POST",
		dataType: "json",
		url: blog_params.ajaxurl,
		data: {
			action: "maillard_theme",
			function: "ajax_display_posts_category",
			data: {
				cat_id: cat_id,
				full_url: full_url,
				num_page: num_page,
			},
		},
		success: function (data) {
			$("#articles").html(data.articles);
			maillardRevealWpbInjected($("#articles"));

			if (data.pagination.current_page == 1) $("#prev-page").addClass("d-none").removeClass("d-flex");
			else $("#prev-page").removeClass("d-none").addClass("d-flex");

			if (data.pagination.current_page === data.pagination.max_num_pages) $("#next-page").addClass("d-none").removeClass("d-flex");
			else $("#next-page").removeClass("d-none").addClass("d-flex");

			$("#pages-count-current").html(data.pagination.current_page < 10 ? "0" + data.pagination.current_page : data.pagination.current_page);
			$("#pages-count-total").html(data.pagination.max_num_pages < 10 ? "0" + data.pagination.max_num_pages : data.pagination.max_num_pages);

			if (!$("#prev-page").length > 0) {
				let prevArrow = $("<div id='prev-page'></div>").attr("data-selected-category", data.selected_cat);
				prevArrow.attr("href", data.pagination.prev_url);
				prevArrow.addClass("fs-4 me-2 cursort-pointer text-secondary");
				data.pagination.current_page <= 1 ? prevArrow.addClass("d-none") : prevArrow.addClass("d-flex");
				const icon = $("#maillard-pagination").attr("data-icon-prev");
				prevArrow.append(icon);
				$("#maillard-pagination").prepend(prevArrow);
				initPrevBtn();
			}

			if (!$("#next-page").length > 0) {
				let nextArrow = $("<div id='next-page'></div>").attr("data-selected-category", data.selected_cat);
				nextArrow.attr("href", data.pagination.next_url);
				nextArrow.addClass("fs-4 ms-2 cursort-pointer text-secondary");
				data.pagination.current_page != data.pagination.max_num_pages ? nextArrow.addClass("d-flex") : nextArrow.addClass("d-none");
				const icon = $("#maillard-pagination").attr("data-icon-next");
				nextArrow.append(icon);
				$("#maillard-pagination").append(nextArrow);
				initNextBtn();
			}

			$("#prev-page")
				.attr("data-current-page", parseInt(num_page) - 1 < 1 ? num_page : parseInt(num_page) - 1)
				.attr("data-selected-category", cat_id);
			$("#prev-page").attr("data-prev-url", data.pagination.prev_url);

			$("#next-page")
				.attr("data-current-page", parseInt(num_page) + 1)
				.attr("data-selected-category", cat_id);
			$("#next-page").attr("data-next-url", data.pagination.next_url);

			$("#articles").show().fadeIn("500");
			$("#maillard-pagination").show().fadeIn("500").addClass("d-flex");
		},
		complete: function (data) {
			$(target).addClass("selected");

			// Changement dans l'url
			window.history.pushState({ path: full_url }, "", full_url);

			// Suppression du loader
			$("#loader-blog").css("z-index", -1).hide().removeClass("d-flex");
		},
	});

	return;
}

function maillard_display_change_page(full_url, cat_id, num_page, mode) {
	if (mode == "prev") {
		/* $("#maillard-pagination").prepend("<img src='"+blog_params.loader_img_alternate+"' /> "); */
		maillard_display_blog_cat(full_url, cat_id, num_page);
	}

	if (mode == "next") {
		/*  $("#maillard-pagination").append(" <img src='"+blog_params.loader_img_alternate+"' />"); */
		maillard_display_blog_cat(full_url, cat_id, num_page);
	}
}

function initPrevBtn() {
	$("#prev-page").click(function (e) {
		e.preventDefault();
		$prev_url = $(this).attr("data-prev-url");
		$selected_cat = $(this).attr("data-selected-category");
		$current_page = parseInt($(this).attr("data-current-page"));
		maillard_display_change_page($prev_url, $selected_cat, $current_page, "prev");
	});
}

function initNextBtn() {
	$("#next-page").click(function (e) {
		e.preventDefault();
		$next_url = $(this).attr("data-next-url");
		$selected_cat = $(this).attr("data-selected-category");
		$current_page = parseInt($(this).attr("data-current-page"));
		maillard_display_change_page($next_url, $selected_cat, $current_page, "next");
	});
}
